module.exports = __webpack_public_path__ + "assets/img/n_browse.f13fdc79.svg";